import type { WalkPersona } from './useWalkthrough'

/**
 * The reader's own persona, from the roles the rest of the app already
 * gates on (composables/useUserRole.ts): ssi_admin is the platform operator,
 * a govt_admin governs a group subtree and reads as a leader, and a tutor is
 * a groupless teacher. This decides which entries carry "yours", never which
 * entries are shown — the page shows everything by ruling.
 *
 * Its own module (job #850) so the learner's Settings and Library screens can
 * ask it without importing handbook.ts, which imports the whole compiled pack.
 */
export function viewerPersona(
  platformRole: string | null | undefined,
  educationalRole: string | null | undefined,
): WalkPersona {
  if (platformRole === 'ssi_admin') return 'admin'
  if (educationalRole === 'govt_admin') return 'leader'
  if (educationalRole === 'school_admin') return 'school_admin'
  if (educationalRole === 'teacher' || educationalRole === 'tutor') return 'teacher'
  return 'learner'
}

/**
 * THE ONE ROLE GATE ON SHOW-ME (job #186, Tom 2026-10-24). A Show-me is offered,
 * listed and playable in-app only to a viewer whose persona is in the walk's
 * `personas`; an SSi admin sees every walk. Every learner is also at the player,
 * so a walk written for learners is open to all of them. An admin-only walk (the
 * marketing-email ones) is therefore never shown to a school admin, teacher,
 * leader or learner. Route every list, launcher and deep link through this.
 */
export function walkVisibleTo(walk: { personas: WalkPersona[] }, persona: WalkPersona): boolean {
  return persona === 'admin' || walk.personas.includes(persona) || walk.personas.includes('learner')
}

/** The persona the filter reads: a View-as overlay stands in for the real role. */
export function filterPersona(
  platformRole: string | null | undefined,
  educationalRole: string | null | undefined,
  viewingAs: boolean,
): WalkPersona {
  return viewerPersona(viewingAs ? null : platformRole, educationalRole)
}
